export default "__VITE_ASSET__9f484a69__"